import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import StickyDonate from "@/components/StickyDonate";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CaregiverResources from "@/pages/CaregiverResources";
import CaregiverBoxes from "@/pages/CaregiverBoxes";
import JaysCorner from "@/pages/JaysCorner";
import CommunityPartnerships from "@/pages/CommunityPartnerships";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/caregiver-resources" element={<CaregiverResources />} />
          <Route path="/caregiver-boxes" element={<CaregiverBoxes />} />
          <Route path="/jays-corner" element={<JaysCorner />} />
          <Route path="/community-partnerships" element={<CommunityPartnerships />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
        <StickyDonate />
      </BrowserRouter>
    </div>
  );
}

export default App;
